import { Container } from '@/components/Container';
import { MapsWidget } from '@/components/MapsWidget';
import { useTranslation } from '@/hooks/useTranslation';

/* ═══════════════════════════════════════════
   MAPA DA ILHA DO MEL
   Embed do Google Maps para visualização
   sem sair do guia
   ═══════════════════════════════════════════ */

const GOOGLE_MAPS_EMBED =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d36804.17861599566!2d-48.34706201293844!3d-25.531418422796897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94dbbc8b7a86c497%3A0xf126aff589ba0796!2sIlha%20do%20Mel!5e0!3m2!1spt-BR!2sbr!4v1777048108887!5m2!1spt-BR!2sbr';

export function MapaSection() {
  const { t } = useTranslation();

  return (
    <section id="mapa" className="py-16 md:py-20 bg-sand-50">
      <Container>
        <div className="max-w-3xl mx-auto text-center mb-10">
          <h2 className="font-display text-3xl md:text-4xl text-warm-dark mb-4">
            {t('guide.map.title')}
          </h2>
          <p className="font-body text-warm-gray text-lg">{t('guide.map.description')}</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <MapsWidget src={GOOGLE_MAPS_EMBED} height={450} title={t('guide.map.iframeTitle')} />
        </div>
      </Container>
    </section>
  );
}
